import React, { createContext, useState } from 'react'
import api from '../services/api'
import { useSocket } from './socketProvider'

type LocationProps = {
  id: string
  accuracy: string
  altitude: string
  latitude: number
  longitude: number
}

type VehicleProps = {
  id: string
  vehicle: string
  color: string
  plate: string
  type: string
}

type BaseProps = {
  id: string
  base: string
  outpost: string
}

type OccurrenceProps = {
  Resident: {
    id_user: string
    name: string
    phone: string
    Base: BaseProps
    Vehicle: VehicleProps[]
  }
  Employee: unknown[]
  outpost: string
  occurrence_id: string
  occurrence_name: string
  occurrence_code: string
  occurrence_type: string
  occurrence_status: string
  additional_info: string
  location: LocationProps[]
  created_at: string
}

type CostumersProps = {
  id: string
  value: string
}

type SecuritiesProps = {
  id: string
  Userinfo: {
    id: string
    name: string
    email: string
    phone: string
  }
  Employee: {
    id: string
    status: string
  }
  Location: null
  online: string
}

type ContextProps = {
  occurrencesList: OccurrenceProps | null
  costumersList: CostumersProps | null
  // filters: unknown
  handleFilters: (field, value) => void
  getAllOccurrences: () => void
  getCostumersList: () => void
  callFilteredOccurrences: () => void
  getSecuritiesList: (occurrenceId: string, baseId: string) => void
  securitiesList: SecuritiesProps | null
  triggerSecurity: (occurrence: OccurrenceProps, idEmployee: string) => void
  triggerSecuritySuccess: boolean
}

export const ContextLatestRequests = createContext<ContextProps | undefined>(
  undefined,
)

const ContextLatestRequestsProvider = (props) => {
  const { socket } = useSocket()

  const [occurrencesList, setOccurrencesList] =
    useState<OccurrenceProps | null>(null)
  const [costumersList, setCostumersList] = useState<CostumersProps | null>(
    null,
  )
  const [securitiesList, setSecuritiesList] = useState<SecuritiesProps | null>(
    null,
  )
  const [filteredData, setFilteredData] = useState({
    customer: '',
    start_date: '',
    start_hour: '',
    end_hour: '23:59',
    status: '',
  })

  const [filter, setFilter] = useState({
    customer: '',
    start_date: '',
    start_hour: '',
    end_hour: '23:59',
    status: '',
  })

  const [triggerSecuritySuccess, setTriggerSecuritySuccess] = useState(false)

  const handleFilters = (field, value) => {
    setFilter((prevItem) => ({
      ...prevItem,
      [field]: value,
    }))
    console.log(filter)
  }

  const getSecuritiesList = (occurrenceId, idBase) => {
    console.log(occurrenceId, idBase)
    api
      .post('/v1/dashboard/employees/online', {
        id_base: idBase,
        id_occurrence: occurrenceId,
      })
      .then((response) => {
        console.log(response.data)
        const data = response.data
        const availableSecurity = data.filter(
          (el) => el.Employee.status !== 'OCORRENCIA',
        )
        setSecuritiesList(availableSecurity)
      })
      .catch((error) => {
        console.log(error.response.data.statusCode)
      })
  }

  const getCostumersList = () => {
    api
      .post('/v1/dashboard/surveillance/occurrences', {})
      .then((response) => {
        const res = response.data
        const list = res.map((item) => {
          const id = item.Resident.id_user
          const value = item.Resident.name

          return { id, value }
        })
        const listSet = [...new Set(list)]
        setCostumersList(listSet)
      })
      .catch((error) => {
        console.log(error.response.data.statusCode)
      })
  }

  const getAllOccurrences = () => {
    api
      .post('/v1/dashboard/surveillance/occurrences', {})
      .then((response) => {
        setOccurrencesList(response.data)
      })
      .catch((error) => {
        console.log(error.response.data.statusCode)
      })
  }

  const triggerSecurity = (occurrence, idEmployee) => {
    const payload = {
      id_occurrence: occurrence.Occurrence.id,
      id_employee: idEmployee,
    }
    console.log(payload)

    socket.emit('occurrences:notification', payload)
    setTriggerSecuritySuccess(true)
    // api
    //   .put('/v1/occurrences/update', dataJson)
    //   .then((res) => {
    //     console.log(res)
    //     setTriggerSecuritySuccess(true)
    //   })
    //   .catch((err) => {
    //     console.log(err)
    //     setTriggerSecuritySuccess(false)
    //   })
  }

  const contextValue: ContextProps = {
    occurrencesList,
    costumersList,
    handleFilters,
    getAllOccurrences,
    getCostumersList,
    setOccurrencesList,
    getSecuritiesList,
    securitiesList,
    triggerSecurity,
    triggerSecuritySuccess,
    filter,
    filteredData,
    setFilter,
    setFilteredData,
  }

  return (
    <ContextLatestRequests.Provider value={contextValue}>
      {props.children}
    </ContextLatestRequests.Provider>
  )
}

export default ContextLatestRequestsProvider
